(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tte-mobile-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tte-mobile-purchase')) {
 customElements.define('tte-mobile-purchase', class extends HTMLElement {
  connectedCallback() {
   this.syncQuantity = (event) => {
    const source = document.getElementById(this.dataset.mainForm)?.elements.namedItem('quantity');
    if (!source || (event && event.target !== source)) return;
    const target = this.querySelector('[name="quantity"]');
    if (source.checkValidity() && target.value !== source.value) {
     target.value = source.value;
     target.dispatchEvent(new Event('change', { bubbles: true }));
    }
   };
   document.addEventListener('change', this.syncQuantity);
   this.syncQuantity();
  }
  disconnectedCallback() { document.removeEventListener('change', this.syncQuantity); }
 });
}
  } catch(e) { console.error(e); }
})();

})();
